import { Component, inject } from '@angular/core'
import { ConfigService } from './core/services/config.service'
import { DevService } from './core/services/dev.service'
import { AnalyticsService } from './core/services/analytics.service'
import { FormService } from './core/services/form.service'
import { HeapService } from './core/services/heap.service'
import { AppInitService, AppInitStatus } from './core/services/app-init.service'
import { CommonModule } from '@angular/common'
import { toObservable } from '@angular/core/rxjs-interop'
import { TagManagerService } from './core/services/tag-manager.service'
import { ComparisonService } from './core/services/comparison.service'
import { MatBottomSheetModule } from '@angular/material/bottom-sheet'
import { MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSnackBarModule } from '@angular/material/snack-bar'
import { AuthModule } from '@auth0/auth0-angular'
import { ComparisonBannerComponent } from './components/comparison-banner/comparison-banner.component'
import { RouterModule } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [
    RouterModule,
    CommonModule,
    AuthModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatIconModule,
    ComparisonBannerComponent,
  ],
})
export class AppComponent {
  private _configService = inject(ConfigService)
  private _devService = inject(DevService)
  private _analyticsService = inject(AnalyticsService)
  private _tagManagerService = inject(TagManagerService)
  private _formService = inject(FormService)
  private _heapService = inject(HeapService)
  private _appInitService = inject(AppInitService)
  protected comparisonService = inject(ComparisonService)

  title = 'sales-webshop'
  adminMode: boolean = false

  theme: any
  loadedOverrides: any

  status: AppInitStatus = AppInitStatus.Loading
  AppInitStatus = AppInitStatus

  constructor() {
    toObservable(this._appInitService.status).subscribe((status: AppInitStatus) => {
      switch (status) {
        case AppInitStatus.Success:
          this.theme = this._configService.config().theme
          this._tagManagerService.init()
          this._devService.init()
          this._analyticsService.init()
          this._formService.init()
          this._heapService.init()
          break
        case AppInitStatus.SuccessAdmin:
          this._devService.init()
          break
      }
      this.status = status
    })
  }
}
